import { devOrProd } from './utils/dev_or_prod'

const duoduoMallChannelId = devOrProd(
  '100000,200000,1400000,2800000',
  '100000,200000',
)

/** 获取运营渠道 ID */
export function getChannelId(url: string) {
  return decodeURIComponent(
    url.match(/[?&](?:refUserGroupId)=(.*?)([#&\b]|$)/)?.[1] ||
      duoduoMallChannelId,
  )!
}

/** 运营渠道 ID */
export const currentChannelId = getChannelId(location.href)

/** 是否全国版渠道 */
export const isChinaChannel = currentChannelId === devOrProd('200000', '200000')

/** 获取销售渠道 ID */
export function getSaleChannelId(url: string) {
  return decodeURIComponent(
    url.match(/[?&](?:sellChannelId)=(.*?)([#&\b]|$)/)?.[1] || '',
  )
}

/** 销售渠道 ID */
export const currentSaleChannelId = getSaleChannelId(location.href)

export const isDuoduoMallChannel = currentChannelId === duoduoMallChannelId

/** 是否所有渠道都和当前相同 */
export function isAllChannelSameAsCurrent(url: string) {
  return (
    getChannelId(url) === currentChannelId &&
    getSaleChannelId(url) === currentSaleChannelId
  )
}
